import { render, staticRenderFns } from "./PriceAnalysis.vue?vue&type=template&id=2a349dd4&scoped=true&"
import script from "./PriceAnalysis.vue?vue&type=script&lang=js&"
export * from "./PriceAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a349dd4",
  null
  
)

export default component.exports